module.exports = __webpack_public_path__ + "static/media/draft.e1d47756.svg";